// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nnIYO","newExpiryDate":"styles_newExpiryDate__2yOEd","footer":"styles_footer__FBI6f"};